<script setup lang="ts">
const { label, passwordMatches } = defineProps({
  label: String,
  passwordMatches: Boolean,
});
</script>

<template>
  <div class="root">
    <div
      class="icon-container"
      role="img"
      :aria-label="
        passwordMatches ? $t('createPassword.filled_checkbox_image_alt') : $t('createPassword.empty_checkbox_image_alt')
      ">
      <div :class="['password-matches-checkbox-icon icon', { 'icon--visible': passwordMatches }]" />
      <div :class="['empty-circle-icon icon', { 'icon--visible': !passwordMatches }]" />
    </div>
    {{ label }}
  </div>
</template>

<style scoped>
.root {
  display: grid;
  grid-template-columns: min-content auto;
  column-gap: 0.5rem;
  align-items: center;
}

.empty-circle-icon {
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.password-matches-checkbox-icon {
  background-image: url('@/assets/img/ico-check.svg');
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
}

.icon {
  opacity: 0;
  transition: opacity 0.35s;
  width: 15px;
  height: 15px;
  position: absolute;
  top: 0;
  left: 0;

  &.icon--visible {
    opacity: 1;
  }
}

.icon-container {
  position: relative;
  width: 15px;
  height: 15px;
}
</style>
